import NamedResource from "./namedResource";
import {ExternalIdentityResource, ClaimsBasedIdentity} from "./identityResource";

export class UserResource extends NamedResource {
    DisplayName: string;
    Username: string;
    IsActive: boolean;
    IsService: boolean;
    EmailAddress?: string;
    CanPasswordBeEdited?: boolean;
    IsRequestor?: boolean;
    Identities: ClaimsBasedIdentity[];

    Password?: string;

    constructor() {
        super();
        this.Name = this.DisplayName;
    }
}

export default UserResource;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/resources/userResource.ts